<div class="header">
  <div class="header-logo">
    <img class="title" src="../../../assets/images/Logo_PRO_Carbono.png">
    <img class="logo-bayer" src="../../../assets/images/bayer-logo-landing.png">
  </div>
  <div class="header-text">
      <p>Cultivando um futuro ainda mais sustentável</p>
  </div>
</div>
